import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import LmTextField from '../../../components/common/LmTextField';
import VegaDatePicker from '../../../components/common/VegaDatePicker';
import VegaFormInputField from '../../../components/common/VegaFormInputField';
import {
  receiptState,
  setIssueReceipt,
} from '../../../features/receiptManagmentSlice';
import { VegaSelectOption } from '../../../components/common/VegaSelect';
import { useAppDispatch, useAppSelector } from '../../../store';
import { DDPayment, IssueReceiptProps } from '../../../types/receiptManagment';
import { DateUtility } from '../../../utils/DateUtlility';
import VegaAutoComplete from '../../../components/common/VegaAutoComplete';
import { fetchCustomerBanksList } from '../../../Apis/customerBank';
import { ICustomerBankListProps } from '../../../types/customerBank';
import { getErrorMessageFromErrorObj } from '../../../utils/api';
import { useSnackbar } from '../../../providers/SnackbarProvider';
import { BankCustomerRequest } from '../../../types/customerBank';
const DDPaymentDetails = () => {
  const { issueReceipt, errorState } = useAppSelector(receiptState);
  const dispatch = useAppDispatch();
  const { setSnackbar } = useSnackbar();
  const ddDetails = issueReceipt?.paymentMeta as DDPayment;
  const onReceiptChange = (key: keyof IssueReceiptProps, value: DDPayment) => {
    const paymentDetailsObj = {
      ...issueReceipt,
      [key]: value,
    } as IssueReceiptProps;
    dispatch(setIssueReceipt(paymentDetailsObj));
  };

  const onDDPaymentChange = (key: keyof DDPayment, value: string) => {
    const paymentSpread = { ...issueReceipt?.paymentMeta };
    const DDPaymentDetailsObj = {
      ...paymentSpread,
      [key]: value,
    } as DDPayment;
    onReceiptChange('paymentMeta', DDPaymentDetailsObj);
  };

  const onDDDateChange = (key: keyof DDPayment, value: any) => {
    const dateToIsoString =
      DateUtility.parseDateFromDatePicker(value)?.toISOString();
    const paymentSpread = { ...issueReceipt?.paymentMeta };
    const DDPaymentDetailsObj = {
      ...paymentSpread,
      [key]: dateToIsoString,
    } as DDPayment;
    onReceiptChange('paymentMeta', DDPaymentDetailsObj);
  };

  const [bankDepositList, setBankDepositList] = useState<VegaSelectOption[]>(
    []
  );
  const [search, setSearch] = useState<string>('');
  const [page, setPage] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [bankResult, setBankResult] = useState([]);
  const [totalItem, setTotalItem] = useState<number>(0);
  const onDDMicrPaymentChange = (data: any) => {
    const paymentSpread = { ...issueReceipt?.paymentMeta };
    const { ifsc, ...dataWithoutIfsc } = data;

    const DDPaymentDetailsObj = {
      ...paymentSpread,
      ...dataWithoutIfsc,
      ifscCode: data.ifsc,
    } as DDPayment;
    onReceiptChange('paymentMeta', DDPaymentDetailsObj);
  };
  const loadMoreItems = (event: any) => {
    if (
      event.target.scrollTop + 1 + event.target.clientHeight >=
      event.target.scrollHeight
    ) {
      if (totalItem !== bankDepositList.length) {
        setPage(page + 1);
      }
    }
  };
  const getCustomerBank = async (request: Partial<BankCustomerRequest>) => {
    try {
      const response = await fetchCustomerBanksList(request);

      // setBankResult(response?.records);
      const newArr = response?.records?.map(
        (customerBank: ICustomerBankListProps) => {
          return {
            value: customerBank.micr,
            label: `${customerBank.micr} - ${customerBank.bankName} - ${customerBank.branchName}`,
          } as VegaSelectOption;
        }
      );
      // setBankDepositList(newArr);
      if (page === 0) {
        setBankDepositList(newArr);
        setBankResult(response?.records);
      } else {
        setBankDepositList([...bankDepositList, ...newArr]);
        setBankResult([...bankResult, ...response?.records]);
      }
      setTotalItem(response?.totalItems);
    } catch (error) {
      setSnackbar(
        getErrorMessageFromErrorObj(error, 'Failed to get Customer Bank List'),
        'error'
      );
    }
  };

  useEffect(() => {
    getCustomerBank({ micr: search, page, size });
  }, [page, size, search]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <VegaFormInputField label={'dd number'} isMandatory>
          <LmTextField
            type="text"
            value={ddDetails?.ddNumber}
            onChange={e => {
              const value = e.target.value;
              onDDPaymentChange('ddNumber', value);
            }}
            error={errorState.error.ddNumber?.length > 0}
            helperText={errorState.error.ddNumber}
          />
        </VegaFormInputField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <VegaFormInputField label={'dd date'}>
          <VegaDatePicker
            type="text"
            value={ddDetails?.ddDate}
            onChange={e => {
              onDDDateChange('ddDate', e);
            }}
          />
        </VegaFormInputField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <VegaFormInputField label={'MICR'} isMandatory>
          <VegaAutoComplete
            searchValue={search}
            handleChange={e => {
              setSearch(e.target.value);
              setPage(0);
            }}
            options={bankDepositList}
            onClear={() => onDDMicrPaymentChange('')}
            onSelect={e => {
              const data = bankResult.filter(item => item.micr === e);
              onDDMicrPaymentChange(data[0]);
            }}
            selected={ddDetails?.micr ?? ''}
            onScroll={loadMoreItems}
            placeHolder="Select MICR"
            ignoreLodash
            specificDisplay
          />
        </VegaFormInputField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <VegaFormInputField label={'Bank Name'}>
          <LmTextField
            type="text"
            disabled
            value={ddDetails?.bankName}
            error={errorState.error.bankName?.length > 0}
            helperText={errorState.error.bankName}
          />
        </VegaFormInputField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <VegaFormInputField label={'Branch Name'}>
          <LmTextField
            type="text"
            disabled
            value={ddDetails?.branchName}
            error={errorState.error.branchName?.length > 0}
            helperText={errorState.error.branchName}
          />
        </VegaFormInputField>
      </Grid>
    </Grid>
  );
};

export default DDPaymentDetails;
